export const SET_GROUP_AVAILABILITY_DATA = 'SET_GROUP_AVAILABILITY_DATA'

export const setGroupAvailabilityData = (key, data) => ({
  type: SET_GROUP_AVAILABILITY_DATA,
  payload: { key, data }
})
